import { MessageBox, Indicator, Toast } from 'mint-ui';
import api from '@/api';
import app from '@/common/app';
import config from '@/config/api-config';
export default {
  callOut (context, { caller, callee, orderId, orderType }) {
    const params = {
      title: '确定要拨打电话吗?',
      subTitle: '',
      confirm: async () => {
        const params = {
          caller,
          callee,
          orderId,
          orderType
        };
        try {
          Indicator.open();
          let rs = await api.phone_call_out(params);
          Indicator.close();
          if (String(rs._ret) === '0') {
            Toast({
              message: rs.data.tips || '拨号中，请耐心等候',
              duration: 10000
            });
          }
        } catch (e) {
          Indicator.close();
          return false;
        }
      },
      cancel: () => {
        return false;
      }
    };
    if (!config.isDev) {
      app.messageBox(params);
      return false;
    }
    MessageBox.confirm('确定要拨打电话吗?')
      .then(async function () {
        const params = {
          caller,
          callee,
          orderId,
          orderType
        };
        try {
          Indicator.open();
          let rs = await api.phone_call_out(params);
          Indicator.close();
          if (String(rs._ret) === '0') {
            console.log(rs, '111');
            Toast({
              message: rs.data.tips || '拨号中，请耐心等候',
              duration: 7000
            });
          }
        } catch (e) {
          Indicator.close();
          return false;
        }
      })
      .catch(() => {
        return false;
      });
  },
  operationToDoor (
    context,
    {
      orderId,
      operationType,
      title,
      operationUser,
      longitude,
      latitude,
      startTime,
      endTime
    }
  ) {
    return new Promise((resolve, reject) => {
      const params = {
        title,
        subTitle: '',
        confirm: async () => {
          const params = {
            orderId,
            operationType,
            operationUser,
            longitude,
            latitude,
            startTime,
            endTime
          };
          try {
            api
              .order_operation(params)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        },
        cancel: () => {
          reject();
          return false;
        }
      };
      if (!config.isDev) {
        app.messageBox(params);
        return false;
      }
      MessageBox.confirm(title)
        .then(async function () {
          const params = {
            orderId,
            operationType,
            operationUser,
            longitude,
            latitude,
            startTime,
            endTime
          };
          try {
            api
              .order_operation(params)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        })
        .catch(() => {
          reject();
          return false;
        });
    });
  },
  inStock (context, { barCode, orderId }) {
    return new Promise((resolve, reject) => {
      const params = {
        title: '确认将该订单更新为已入库状态？',
        subTitle: '',
        confirm: async () => {
          const params = {
            barCode,
            orderId
          };
          try {
            api
              .putInStock(params)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        },
        cancel: () => {
          reject();
          return false;
        }
      };
      if (!config.isDev) {
        app.messageBox(params);
        return false;
      }
      MessageBox.confirm('确认将该订单更新为已入库状态？')
        .then(async function () {
          const params = {
            barCode,
            orderId
          };
          try {
            api
              .putInStock(params)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        })
        .catch(() => {
          reject();
          return false;
        });
    });
  },
  confirmDelivery (context, { sendStockId }) {
    return new Promise((resolve, reject) => {
      const params = {
        title: '您确认已将机器交给快递员了吗？',
        subTitle: '',
        confirm: async () => {
          const params = {
            sendStockId
          };
          try {
            api
              .confirmDelivery(params)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        },
        cancel: () => {
          reject();
          return false;
        }
      };
      if (!config.isDev) {
        app.messageBox(params);
        return false;
      }
      MessageBox.confirm('您确认已将机器交给快递员了吗？')
        .then(async function () {
          const params = {
            sendStockId
          };
          try {
            api
              .confirmDelivery(params)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        })
        .catch(() => {
          reject();
          return false;
        });
    });
  },
  createOrderAction (context, postData) {
    return new Promise((resolve, reject) => {
      const params = {
        title: '确认将该订单更新为出库状态？',
        subTitle: '',
        confirm: async () => {
          try {
            api
              .sendStockItem(postData)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        },
        cancel: () => {
          reject();
          return false;
        }
      };
      if (!config.isDev) {
        app.messageBox(params);
        return false;
      }
      MessageBox.confirm('确认将该订单更新为出库状态？')
        .then(async function () {
          try {
            api
              .sendStockItem(postData)
              .then((res) => {
                resolve(res);
              })
              .catch((error) => {
                reject(error);
              });
          } catch (e) {
            reject(e);
            return false;
          }
        })
        .catch(() => {
          reject();
          return false;
        });
    });
  }
};
